import React, { lazy, Suspense } from 'react';
import { useAuth } from '../../providers/auth-providers';

interface SearchAIContainerProps {
    searchTerm: string;
    isAiSummaryFooterContentAndLinkEnabled?: boolean;
}

const SearchAI = lazy(() =>
    // @ts-ignore
    import('./search-ai').then((module) => ({
        default: module.SearchAI
    }))
);

export const SearchAIContainer = ({
    searchTerm,
    isAiSummaryFooterContentAndLinkEnabled
}: SearchAIContainerProps) => {
    const { aaId } = useAuth();

    if (!aaId) {
        return null;
    }

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <SearchAI
                searchTerm={searchTerm}
                isAiSummaryFooterContentAndLinkEnabled={
                    isAiSummaryFooterContentAndLinkEnabled
                }
            />
        </Suspense>
    );
};
